module.exports = __webpack_public_path__ + "img/16.280794f6.png";